<template>
  <div class="" v-if="status != null">
    <p
      class="w-8 h-8 flex opacity-li5 items-center justify-center main font-semibold rounded-full border-green text-success"
      v-if="status > 0"
    >
      {{ status }}
    </p>

    <p
      class="py-1 px-2 main rounded opacity-li5 border-danger bgcolorred font-semibold text-white"
      v-if="status < 0"
    >
      Expired
    </p>
    <p
      class="py-1 px-2 main opacity-li5 rounded border-green green font-semibold text-white"
      v-if="status == 'Assigned'"
    >
      Assigned
    </p>
  </div>
</template>

<script>
export default {
  props: {
    status: null,
  },
  watch: {
    status() {
      console.log(this.status, "statusstatusstatusstatus");
    },
  },
};
</script>
<style>
.red {
  background-color: red !important;
}

.green {
  background-color: green;
}

.main {
  font-size: 9px !important;
}
.bgcolorred {
  background-color: #ff5c5c;
}
.opacity-li5 {
  opacity: 0.7;
}
</style>
